export default __webpack_public_path__ + "img/academy.2a9c8613.jpeg";